<div class="h-full flex flex-col text-white border-neutral-600 scrollbar-dark">
  <div
    class="grid grid-cols-[auto_1fr_auto] gap-2 items-center border-b border-neutral-600 py-6 px-4 dark"
  >
    <button
      (click)="onCloseClick()"
      class="flex flx-ds primary w-fit"
      icon="center"
      flxButton
      variant="text"
    >
      <i
        class="ph ph-arrow-left"
        flxIcon
      ></i>
    </button>

    <span class="font-bold text-xl leading-8">Select Context Document</span>

    <button
      (click)="documentInput.click()"
      class="flex items-center h-8 text-xs/[18px] rounded-[8px] px-[8px] py-[4px] text-xs bg-neutral-600 gap-2 self-end"
    >
      <i class="ph ph-sparkle text-yellow-500 text-[12px]"></i>
      <span class="text-white">Upload New Document</span>
    </button>
  </div>

  <div class="px-6 py-4 flex flex-col gap-2 overflow-y-auto">
    <div class="flex flex-col">
      @for (document of documents(); track document.id; let index = $index) {
        @if (document.status !== AiDocumentStatus.FAILED) {
          <div
            [ngClass]="{
              'hover:bg-black/10 cursor-pointer rounded-lg': document.isReady,
              'bg-transparent': !document.isReady,
              'loading': !document.isReady,
            }"
            [style.--animation-offset]="index * 0.5 + 's'"
            (click)="onDocumentClick(document)"
            class="grid grid-cols-[auto_1fr_auto] items-center gap-2 p-2"
          >
            <i class="ph ph-file text-neutral-400 text-sm"></i>
            <div
              [ngClass]="{ 'opacity-50': !document.isReady }"
              class="flex items-center gap-2 break-all"
            >
              {{ document.filename }}
              @if (document.isNew) {
                <i class="ph-fill ph-circle text-yellow-500 text-[7px]"></i>
              }
            </div>

            <div class="flex align-self-end gap-2 min-w-max">
              @if (document.isReady && document.status !== AiDocumentStatus.FAILED) {
                @for (tag of document.tags; track tag) {
                  <div class="text-xs text-neutral-200 bg-neutral-700 rounded-lg px-2 py-1">
                    {{ tag }}
                  </div>
                }
              }

              @if (document.status === AiDocumentStatus.FAILED) {
                <div class="text-xs text-red-400 rounded-lg px-2 py-1">Could not process</div>
              }

              @if (!document.isReady && document.status !== AiDocumentStatus.FAILED) {
                <div class="text-xs text-white opacity-50 rounded-lg px-2 py-1 italic">
                  Processing...
                </div>
                <flx-ai-loading-spinner
                  (click)="onCancelProcessing(document, $event)"
                  class="h-5 inline-flex items-center cursor-pointer"
                />
              }
            </div>
          </div>
        }
      }
    </div>

    @if (failedDocuments().length > 0) {
      @for (document of failedDocuments(); track document.id) {
        <div
          class="failed-document-item flex items-center justify-between bg-red-900/30 rounded-lg p-2 gap-2"
        >
          <div class="flex items-center gap-2">
            <i class="ph ph-warning-circle text-red-500 text-xs"></i>
            <span class="text-xs text-white">{{ document.filename }} was not processed.</span>
          </div>

          <button
            (click)="onRetryDocument(document, $event)"
            class="flex items-center gap-2 px-2 py-1 bg-white/10 hover:bg-neutral-600 rounded-lg transition-colors text-xs text-white"
          >
            <i class="ph ph-arrow-clockwise"></i>
            Retry
          </button>
        </div>
      }
    }

    @if (processingDocumentsNames().length > 0) {
      <div class="text-xs text-neutral-200 bg-neutral-700 rounded-lg p-2 flex items-center gap-2">
        <i class="ph ph-lightbulb text-yellow-500 text-md"></i>
        <div>
          <span class="font-bold">
            {{ processingDocumentsNames().join(', ') }}
          </span>
          {{ processingDocumentsNames().length === 1 ? 'is' : 'are' }} being uploaded. This may take
          a while, you can work on other things in the meantime
        </div>
      </div>
    }
  </div>
</div>

<div
  [class.hiding-resource-list]="!showResourceList()"
  class="resource-list-wrapper w-full"
>
  <flx-document-resource-list
    [selectedDocument]="selectedDocument()"
    [type]="agentDocumentType()"
    (closed)="onResourceListClosed($event)"
  />
</div>

<input
  #documentInput
  [accept]="allowedDocumentFileTypes()"
  [multiple]="false"
  (change)="onDocumentSelected($event)"
  class="hidden"
  type="file"
/>
